//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'AppMain',
  computed: {
    cachedViews: function cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    noCachedViews: function noCachedViews() {
      return !this.$route.meta.noKeepAlive;
    },
    key: function key() {
      return this.$route.path;
    }
  }
};